// PieChart.tsx
import React from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import { formatBudget } from "../../../utils/formateNumber";
type Props = {
  series: any[];
}

const normalizeSeries = (series: any[]) => {
  return series.map(item => {
    const raw = item.value; // "R 14K"
    const val = raw.replace(/[R\s]/g, "").toUpperCase();

    let numericValue = 0;

    if (val.endsWith("K")) {
      numericValue = parseFloat(val.replace("K", "")) * 1000;
    } else if (val.endsWith("M")) {
      numericValue = parseFloat(val.replace("M", "")) * 1000000;
    } else if (val.endsWith("B")) {
      numericValue = parseFloat(val.replace("B", "")) * 1000000000;
    } else if (val.endsWith("T")) { numericValue = parseFloat(val.replace("T", "")) * 1000000000000; }
    else {
      numericValue = parseFloat(val) || 0;
    }

    return {
      ...item,
      value: numericValue,
      displayValue: formatBudget(raw) // keep original value for labels
    };
  });
};



const CustomizedPieChart = React.forwardRef<ReactECharts, Props>(({ series }, ref) => {
  const cleanedSeries = normalizeSeries(series);

  const option: echarts.EChartsOption = {
    legend: {
      orient: "horizontal",
      icon: "circle",
      bottom: 0,
      textStyle: {
        fontSize: 12,
      }
    },
    tooltip: {
      trigger: "item",
    },
    label: {
      show: true,
      formatter: (params: any) => {
        return `${params.name} : ${params.data.displayValue}`;
      }
    },
    series: [
      {
        name: "",
        type: "pie",
        radius: "55%",
        center: ["50%", "50%"],
        data: cleanedSeries,
        roseType: "radius",
        itemStyle: {
          shadowBlur: 20,
          shadowOffsetX: 5,
          shadowOffsetY: 5,
          shadowColor: "rgba(0, 0, 0, 0.3)"
        },
        animationType: "scale",
        animationEasing: "elasticOut",
        animationDelay: () => Math.random() * 200
      },
    ],
  };

  return <ReactECharts ref={ref} option={option} style={{ height: "400px", width: "100%" }} />;
});


export default CustomizedPieChart;